/**
 * Module: Newsletter
 */

jQuery( $ => {
	/**
	 * Toggles the Accept box information.
	 *
	 * @param {Object} el the element that should be activated.
	 */
	function toggleAcceptBox( el ) {
		// Add active class.
		el.addClass( 'active' );
	}

	/**
	 * Show terms and conditions on input in email input field in mailchimp form.
	 */
	$( '.mc4wp-form-fields input[type="email"]' ).on( 'input', function() {
		const toggleEl = $( this ).siblings( 'p' );
		toggleAcceptBox( toggleEl );
	} );
} );
